
<template>
  <div>
    <ErrorMessage
      v-show="errorMessage != null && errorMessage != ''"
      :msg="errorMessage"
    ></ErrorMessage>
    <select
      v-model="values"
      class="form-select form-select-new page-body-font pt-0 pb-0"
      style="color: rgb(0, 0, 0); font-family: 'メイリオ', 'Meiryo', sans-serif"
      :class="[
        errorStyle,
        textCenter == true ? 'text_center' : '',
        dateCenter == true ? 'date_center' : ''
      ]"
      :disabled="disabled"
      @click="select"
      @input="$emit('input', $event.target.value)"
    >
      <!-- <option v-show="!required" value="">ーー</option> -->
      <option v-for="opt in selectOption" :key="opt.id" :value="opt.id">
        {{ opt.name }}
      </option>
    </select>
  </div>
</template>

<script>
import ErrorMessage from './ErrorMessage.vue'
export default {
  name: 'InputSelect',
  components: { ErrorMessage },
  props: {
    errorMessage: String,
    value: [String, Number],
    hidden: Boolean,
    options: Array,
    required: Boolean,
    disabled: Boolean,
    textCenter: Boolean,
    dateCenter: Boolean
  },
  data() {
    return {
      errorStyle: '',
      selectOption: [],
      values: ''
    }
  },
  watch: {
    errorMessage: {
      immediate: true,
      handler(value) {
        if (value != null && value !== '') {
          this.errorStyle = 'errorStyle'
        } else {
          this.errorStyle = ''
        }
      }
    },
    values(selectValue) {
      this.$set(this.$data, 'values', selectValue)
    },
    options(value) {
      this.selecList(value)
    }
  },
  mounted() {
    this.selecList(this.options)
  },
  methods: {
    selecList(list) {
      this.selectOption = [{ id: '', name: 'ーー' }]
      list.forEach((value, i) => {
        if (this.required === false) {
          this.selectOption[i + 1] = value
        } else {
          this.selectOption[i] = value
        }
        this.selectValue = value.name
        this.values = this.value
      })
      if (this.value === '' || this.value === null || this.value === undefined) {
        this.values = ''
      } else {
        this.values = this.value
      }
    },
    select() {
      this.$emit('select')
    }
  }
}
</script>

<style scoped lang="scss">
.text_center {
  text-align: center;
  padding: 0;
}
.date_center {
  text-align: center;
}
.errorStyle {
  background-color: rgb(255, 220, 221);
  border-color: red;
  border: 1;
}
.form-select-new {
  height: 25px !important;
  font-size: 14px;
}
</style>
